import { render, staticRenderFns } from "./item.vue?vue&type=template&id=5c3094fc&scoped=true&lang=pug&"
import script from "./item.vue?vue&type=script&lang=coffee&"
export * from "./item.vue?vue&type=script&lang=coffee&"
import style0 from "./item.vue?vue&type=style&index=0&id=5c3094fc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3094fc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AccessibilityBtn: require('/opt/build/repo/library/components/globals/accessibility-btn.vue').default,SmartLink: require('/opt/build/repo/nuxt-app/components/globals/smart-link.coffee').default})
